export const BETBY_STATUS_LABELS = {
  pending: 'status.pending',
  win: 'status.won',
  lost: 'status.lost',
  cashout: 'status.cashout',
  refund: 'status.refund',
  discard: 'status.null_bet',
}

export const BETBY_STATUS_CLASSES = {
  pending: 'badge badge-warning p-1 rounded',
  win: 'badge badge-success p-1 rounded',
  lost: 'badge badge-danger p-1 rounded',
  cashout: 'badge badge-info p-1 rounded',
  refund: 'badge badge-secondary p-1 rounded',
  discard: 'badge badge-secondary p-1 rounded',
}

export const BETBY_SETTLED_STATUSES = ['win', 'lost', 'cashout', 'refund', 'discard']

export const betbyIsSettled = (status) => BETBY_SETTLED_STATUSES.includes(status)

export const betbyStatusKey = (status) => BETBY_STATUS_LABELS[status] || null

export const betbyStatusClass = (status) => BETBY_STATUS_CLASSES[status] || ''
